import { cn } from '@/lib/utils';

export function Circle({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 2 2" className={cn('size-0.5 fill-current', className)}>
      <circle cx="1" cy="1" r="1" />
    </svg>
  );
}
